function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff;stroke:#fff}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "download-svgrepo-com",
  transform: "translate(.5 .5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3221",
  "data-name": "Group 3221"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4166",
  d: "M29.068 228.277a.854.854 0 0 0-.857.857v7.8a3.847 3.847 0 0 1-3.842 3.842H5.557a3.847 3.847 0 0 1-3.842-3.842v-7.926a.857.857 0 0 0-1.715 0v7.926a5.563 5.563 0 0 0 5.557 5.557h18.812a5.563 5.563 0 0 0 5.557-5.557v-7.8a.858.858 0 0 0-.858-.857z",
  className: "cls-1",
  "data-name": "Path 4166",
  transform: "translate(0 -214.756)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4167",
  d: "M141.933 38.176a.863.863 0 0 0 .6.254.837.837 0 0 0 .6-.254l5.449-5.449a.858.858 0 1 0-1.213-1.213l-3.975 3.986V18.1a.857.857 0 1 0-1.715 0v17.4l-3.988-3.988a.858.858 0 0 0-1.213 1.213z",
  className: "cls-1",
  "data-name": "Path 4167",
  transform: "translate(-127.573 -17.25)"
})));

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.926,
    height: 28.735,
    viewBox: "0 0 30.926 28.735",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-icon.9c63fbe8.svg";
export { ForwardRef as ReactComponent };